'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        asyncAutoUpload: {
            type: Boolean,
            kComposite: 'async.autoUpload'
        },
        asyncBatch: {
            type: Boolean,
            kComposite: 'async.batch'
        },
        asyncChunkSize: {
            type: Number,
            kComposite: 'async.chunkSize'
        },
        asyncConcurrent: {
            type: Boolean,
            kComposite: 'async.concurrent'
        },
        asyncAutoRetryAfter: {
            type: Number,
            kComposite: 'async.autoRetryAfter'
        },
        asyncMaxAutoRetries: {
            type: Number,
            kComposite: 'async.maxAutoRetries'
        },
        asyncRemoveField: {
            type: String,
            kComposite: 'async.removeField'
        },
        asyncRemoveUrl: {
            type: String,
            kComposite: 'async.removeUrl'
        },
        asyncRemoveVerb: {
            type: String,
            kComposite: 'async.removeVerb'
        },
        asyncSaveField: {
            type: String,
            kComposite: 'async.saveField'
        },
        asyncSaveUrl: {
            type: String,
            kComposite: 'async.saveUrl'
        },
        asyncUseArrayBuffer: {
            type: Boolean,
            kComposite: 'async.useArrayBuffer'
        },
        asyncWithCredentials: {
            type: Boolean,
            kComposite: 'async.withCredentials'
        }
    }
};